import axios, { AxiosRequestConfig } from 'axios'
import { api_external_installer_path, api_external_installers_path } from '../routes'

type ExternalInstallerPayload = {
  department_id: number
  name: string
  email: string
}

export function createExternalInstaller(payload: ExternalInstallerPayload) {
  const options: AxiosRequestConfig = {
    url: api_external_installers_path({ format: 'json' }),
    method: 'post',
    responseType: 'json',
    data: payload,
  }

  return axios(options).then(response => response.data)
}

export function updateExternalInstaller(id: number, payload: ExternalInstallerPayload) {
  const options: AxiosRequestConfig = {
    url: api_external_installer_path(id, { format: 'json' }),
    method: 'put',
    responseType: 'json',
    data: payload,
  }

  return axios(options).then(response => response.data)
}

export function deleteExternalInstaller(id: number, payload: { department_id: number }) {
  const options: AxiosRequestConfig = {
    url: api_external_installer_path(id, { format: 'json' }),
    method: 'delete',
    responseType: 'json',
    params: payload,
  }

  return axios(options).then(response => response.data)
}
